import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 18 12";
const LastPageIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M17 0C16.448 0 16 0.448 16 1V11C16 11.552 16.448 12 17 12C17.552 12 18 11.552 18 11V1C18 0.448 17.552 0 17 0ZM1.05078 0.929688C0.514016 0.903578 0 1.32144 0 1.92969V10.0703C0 10.8813 0.913172 11.3547 1.57617 10.8867L7.34375 6.81641C7.90775 6.41841 7.90775 5.58159 7.34375 5.18359L1.57617 1.11328C1.41042 0.996281 1.2297 0.938391 1.05078 0.929688ZM9.05078 0.929688C8.51402 0.903578 8 1.32144 8 1.92969V10.0703C8 10.8813 8.91317 11.3547 9.57617 10.8867L15.3438 6.81641C15.9078 6.41841 15.9078 5.58159 15.3438 5.18359L9.57617 1.11328C9.41042 0.996281 9.2297 0.938391 9.05078 0.929688Z",
      fill: rest.fill
    }
  ) });
};
export {
  LastPageIcon
};
